export const LIST_LEAVES_ROUTE = "/leave";
export const ADD_LEAVE_ROUTE = "/add-leave";
export const CONFIRM_LEAVE_ROUTE = "/confirm-leave";
export const ADD_ADMIN_LEAVE_ROUTE = "/add-admin-leave";
export const ADD_SITE_ADMIN_LEAVE_ROUTE = "/add-admin-leave/:siteId";
export const LIST_SITE_LEAVES_ROUTE = "/leave/:siteId";
export const NEW_LEAVE_PATH = "/leave/new-leave"; 